import { TileLayer } from 'react-leaflet'

const GoogleMapSatelliteLayer = () => {
  return (
    <TileLayer
      maxZoom={20}
      zIndex={200}
      attribution="Google Maps Satellite"
      url="https://www.google.cn/maps/vt?lyrs=s,h@189&gl=cn&x={x}&y={y}&z={z}"
    />
  )
}

export default GoogleMapSatelliteLayer